import type { CSSProperties } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface ChartAreaSkeletonProps {
  className?: string;
  heightClassName?: string;
  style?: CSSProperties;
}

export function ChartAreaSkeleton({
  className,
  heightClassName = "h-full",
  style,
}: ChartAreaSkeletonProps) {
  return (
    <Skeleton
      className={cn("w-full rounded-[1.25rem] border-border/60", heightClassName, className)}
      style={style}
    />
  );
}
